import { useMemo } from 'react';
import { useT } from './provider';
import { useVocab } from './vocab';

/**
 * D577: the name of a country in the console's language — "Brasil", "Portugal" — never `BR` / `PT`. The names come from the
 * platform's region data (`Intl.DisplayNames`), so a country added later needs no entry here; a code the platform cannot name
 * reads as the translated "uncatalogued value", and an absent country as a dash.
 */
export function useCountryName(): (code: string | null | undefined) => string {
  const { lang } = useT();
  const { v } = useVocab();
  return useMemo(() => {
    const regions = (() => {
      try {
        return new Intl.DisplayNames([lang], { type: 'region' });
      } catch {
        return undefined;
      }
    })();
    return (code) => {
      if (code === null || code === undefined || code === '') return v('common.country', code);
      const upper = code.toUpperCase();
      try {
        const name = regions?.of(upper);
        if (name !== undefined && name !== upper) return name;
      } catch {
        // an unreadable code falls through to the uncatalogued value
      }
      return v('common.country', code);
    };
  }, [lang, v]);
}
